import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { CUSTOM_MASK } from '@helpers/custom-validator';
import { enumTypeView } from '@enum/enumTypeView';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { enumIdentifierQualifier } from '@data-layer/enums/common';

@Component({
  selector: 'address-update',
  templateUrl: './address-update.component.html',
  styleUrls: ['./address-update.component.scss'],
})
export class AddressUpdateComponent implements OnInit {
  public enumTypeView: typeof enumTypeView = enumTypeView;

  @Input() public formGroup: UntypedFormGroup;
  @Input() public code: enumEntityModelCode;
  @Input() public errors: { [name: string]: IErrorForm } = {};
  @Input() public isShowState: boolean = true;
  @Input() public isShowCountry: boolean = false;
  @Input() public isAllowCountryDisable: boolean = true;
  @Input() public isShowErrors: boolean = true;
  @Input() public isDesktop: boolean = false;
  @Input() public isFilterRestrictedCountries: boolean = false;
  @Input() public isFilterOnlyUSA: boolean;
  @Input() public isUnitedStates: boolean;
  @Input() public defaultCountry: any = null;
  @Input() public typeView: enumTypeView = enumTypeView.ISF;
  @Input() public isShowRequired: boolean;

  public addressFormGroup: UntypedFormGroup;
  public CUSTOM_MASK: any = CUSTOM_MASK;

  constructor() {}

  public ngOnInit(): void {
    this.addressFormGroup = this.formGroup.get('address') as UntypedFormGroup;
  }

  public get isForeignCompany(): boolean {
    return (
      (!this.formGroup.get('identifierQualifier')?.value ||
        this.formGroup.get('identifierQualifier')?.value === enumIdentifierQualifier.ANI ||
        this.formGroup.get('entityIdentifierQualifier')?.value === enumIdentifierQualifier.ANI) &&
      !this.isUnitedStates
    );
  }
}
